import { Link } from 'react-router-dom';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark-800 border-t border-gray-800">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center space-x-2 mb-4">
              <img
                src="/images/logo.webp"
                alt="SpinEmerge"
                className="h-8 w-auto"
                loading="lazy"
                width="32"
                height="32"
              />
              <span className="text-xl font-bold bg-gradient-to-r from-primary-500 to-accent-500 bg-clip-text text-transparent">
                SpinEmerge
              </span>
            </Link>
            <p className="text-gray-400 text-sm mb-4">
              Your trusted guide to the best UK casino offers. We review, compare, and help you find the perfect casino experience.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-gray-400 hover:text-primary-400 transition-colors text-sm"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/offers"
                  className="text-gray-400 hover:text-primary-400 transition-colors text-sm"
                >
                  Casino Offers
                </Link>
              </li>
              <li>
                <Link
                  to="/comparison"
                  className="text-gray-400 hover:text-primary-400 transition-colors text-sm"
                >
                  Compare Offers
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-gray-400 hover:text-primary-400 transition-colors text-sm"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="text-gray-400 hover:text-primary-400 transition-colors text-sm"
                >
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/terms"
                  className="text-gray-400 hover:text-primary-400 transition-colors text-sm"
                >
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="text-gray-400 hover:text-primary-400 transition-colors text-sm"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/cookies"
                  className="text-gray-400 hover:text-primary-400 transition-colors text-sm"
                >
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Responsible Gaming */}
          <div>
            <h3 className="text-white font-semibold mb-4">Responsible Gaming</h3>
            <div className="grid grid-cols-2 gap-4 mb-4">
              <a
                href="https://www.gambleaware.org"
                target="_blank"
                rel="noopener noreferrer"
                className="block opacity-80 hover:opacity-100 transition-opacity"
              >
                <img
                  src="/images/footer/gambleaware.webp"
                  alt="GambleAware"
                  className="h-12 w-auto mx-auto"
                  loading="lazy"
                />
              </a>
              <a
                href="https://www.gamcare.org.uk"
                target="_blank"
                rel="noopener noreferrer"
                className="block opacity-80 hover:opacity-100 transition-opacity"
              >
                <img
                  src="/images/footer/gamcare.webp"
                  alt="GamCare"
                  className="h-12 w-auto mx-auto"
                  loading="lazy"
                />
              </a>
              <a
                href="https://gamblingtherapy.org"
                target="_blank"
                rel="noopener noreferrer"
                className="block opacity-80 hover:opacity-100 transition-opacity"
              >
                <img
                  src="/images/footer/therapy.webp"
                  alt="Gambling Therapy"
                  className="h-12 w-auto mx-auto"
                  loading="lazy"
                />
              </a>
              <a
                href="https://www.gamblingcommission.gov.uk"
                target="_blank"
                rel="noopener noreferrer"
                className="block opacity-80 hover:opacity-100 transition-opacity"
              >
                <img
                  src="/images/footer/comission.webp"
                  alt="Gambling Commission"
                  className="h-12 w-auto mx-auto"
                  loading="lazy"
                />
              </a>
            </div>
            <p className="text-gray-400 text-xs text-center">
              18+ | BeGambleAware.org | Play Responsibly
            </p>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-500 text-sm text-center md:text-left">
              © {currentYear} SpinEmerge.com. All rights reserved.
            </p>
            <p className="text-gray-500 text-xs text-center md:text-right">
              Licensed operators only | 18+ | Play Responsibly
            </p>
          </div>
          
          {/* 18+ Disclaimer */}
          <div className="mt-6 pt-6 border-t border-gray-800">
            <div className="bg-dark-900/50 border border-gray-700 rounded-lg p-4">
              <div className="flex items-start space-x-3">
                <div className="flex-shrink-0">
                  <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-primary-500/20 text-primary-400 font-bold text-lg">
                    18+
                  </span>
                </div>
                <div className="flex-1">
                  <p className="text-gray-300 text-sm leading-relaxed">
                    <strong className="text-white">18+ Only.</strong> This website is intended for users who are 18 years of age or older. 
                    Gambling can be addictive. Please play responsibly. If you feel you may have a gambling problem, 
                    please seek help from <a href="https://www.gambleaware.org" target="_blank" rel="noopener noreferrer" className="text-primary-400 hover:text-primary-300 underline">GambleAware</a> or <a href="https://www.gamcare.org.uk" target="_blank" rel="noopener noreferrer" className="text-primary-400 hover:text-primary-300 underline">GamCare</a>.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

